(function () {
  document.documentElement.classList.remove('no-js');

  function updateVariantSelection(select, updateUrl) {
    var option = select.options[select.selectedIndex];
    var wrapper = select.closest('[data-product-form]');
    if (!wrapper) return;

    var button = wrapper.querySelector('[data-add-to-cart]');
    var price = wrapper.querySelector('[data-current-price]') || wrapper.querySelector('[data-product-price]');
    var available = option.dataset.available === 'true';

    wrapper.querySelectorAll('[data-variant-swatch]').forEach(function (swatch) {
      swatch.checked = swatch.value === option.value;
    });

    if (button) {
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldoutLabel;
    }

    if (price && option.dataset.price) price.textContent = option.dataset.price;

    var comparison = wrapper.querySelector('[data-compare-price]');
    if (comparison) {
      comparison.textContent = option.dataset.comparePrice || '';
      comparison.hidden = !option.dataset.comparePrice;
    }
    var productSection = select.closest('.product');
    var gallery = productSection ? productSection.querySelector('[data-product-gallery]') : null;
    if (gallery && gallery.showMedia && option.dataset.featuredMediaId) {
      gallery.showMedia(option.dataset.featuredMediaId);
    }

    if (updateUrl && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.from(track.querySelectorAll('[data-product-media-id]'));
    if (!slides.length) return;
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-current]');
    var controls = gallery.querySelector('[data-gallery-controls]');
    var current = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-selected'); }));
    function paint(index) {
      current = index;
      if (counter) counter.textContent = String(index + 1);
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-selected', i === index); });
    }
    function show(index, smooth) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      var left = track.scrollLeft + slides[index].getBoundingClientRect().left - track.getBoundingClientRect().left;
      paint(index);
      track.scrollTo({ left: left, behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    gallery.showMedia = function (id) {
      var index = slides.findIndex(function (slide) { return slide.dataset.productMediaId === id; });
      if (index >= 0) show(index, false);
    };
    if (previous) previous.addEventListener('click', function () { show(current - 1, true); });
    if (next) next.addEventListener('click', function () { show(current + 1, true); });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1), true);
      }
    });
    var frame;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        var left = track.getBoundingClientRect().left;
        var nearest = 0;
        slides.forEach(function (slide, i) {
          if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[nearest].getBoundingClientRect().left - left)) nearest = i;
        });
        paint(nearest);
      });
    }, { passive: true });
    if (controls) controls.hidden = false;
    if ('ResizeObserver' in window) {
      var resize = new ResizeObserver(function () { show(current, false); });
      resize.observe(track);
      gallery.cleanupGallery = function () { resize.disconnect(); window.cancelAnimationFrame(frame); };
    }
    show(current, false);
  }

  function initializeTheme(root) {
    root.querySelectorAll('[data-product-gallery]').forEach(initializeGallery);
    var revealItems = root.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window && revealItems.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealItems.forEach(function (item) { observer.observe(item); });
    } else {
      revealItems.forEach(function (item) { item.classList.add('is-visible'); });
    }

    root.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
      if (rotator.dataset.rotatorReady === 'true') return;
      rotator.dataset.rotatorReady = 'true';
      var messages = rotator.querySelectorAll('[data-announcement-message]');
      if (messages.length < 2) return;
      var current = 0;
      var interval = Math.max(3000, Number(rotator.dataset.interval || 5000));
      var intervalId = window.setInterval(function () {
        messages[current].classList.remove('is-active');
        current = (current + 1) % messages.length;
        messages[current].classList.add('is-active');
      }, interval);
      rotator.dataset.intervalId = String(intervalId);
    });

    root.querySelectorAll('[data-quantity]').forEach(function (control) {
      if (control.dataset.quantityReady === 'true') return;
      control.dataset.quantityReady = 'true';
      var input = control.querySelector('input[type="number"]');
      if (!input) return;
      control.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = Number(input.step || 1);
          var next = Number(input.value || 1) + (button.dataset.action === 'increase' ? step : -step);
          input.value = Math.max(Number(input.min || 1), next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    root.querySelectorAll('[data-variant-select]').forEach(function (select) {
      if (select.dataset.variantReady === 'true') return;
      select.dataset.variantReady = 'true';
      updateVariantSelection(select, false);
      select.addEventListener('change', function () {
        updateVariantSelection(select, true);
      });
    });

    root.querySelectorAll('[data-variant-swatch]').forEach(function (swatch) {
      if (swatch.dataset.swatchReady === 'true') return;
      swatch.dataset.swatchReady = 'true';
      swatch.addEventListener('change', function () {
        var wrapper = swatch.closest('[data-product-form]');
        var select = wrapper ? wrapper.querySelector('[data-variant-select]') : null;
        if (!select || !swatch.checked) return;
        select.value = swatch.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    root.querySelectorAll('.mobile-nav a').forEach(function (link) {
      if (link.dataset.mobileNavReady === 'true') return;
      link.dataset.mobileNavReady = 'true';
      link.addEventListener('click', function () {
        var details = link.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeTheme(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeTheme(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-product-gallery]').forEach(function (gallery) { if (gallery.cleanupGallery) gallery.cleanupGallery(); });
    event.target.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
      if (rotator.dataset.intervalId) window.clearInterval(Number(rotator.dataset.intervalId));
    });
  });
})();

